export default __webpack_public_path__ + "static/content2-3ff203d378435951f4d215d12115d467.png";